import { loadAuthState } from "../actions/auth";
import {
  LOGIN_SUCCESS,
  LOGOUT,
  MASTER_PROFILE,
  PROFILE,
} from "../constants/auth";

const initialState = {
  ...loadAuthState(),
  email: "",
  first_name: "",
  last_name: "",
  mobile: "",
  profile_image: "",
  user_id: "",
  company_master_account: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case PROFILE:
      return {
        ...state,
        ...action.payload,
      };
    case MASTER_PROFILE:
      return {
        ...state,
        company_master_account: {
          ...action.payload,
        },
      };
    case LOGOUT:
      return {
        userName: null,
        token: null,
        isAuthenticated: false,
        expiresAt: null,
      };
    default:
      return state;
  }
};

export default authReducer;
